import { useCallback, useEffect, useState } from "react";

const VISITED_STORAGE_KEY = "operations_visited";
// The browser `storage` event only fires in OTHER tabs, so we broadcast this
// custom event to keep hook instances in the CURRENT tab (e.g. the nav dot)
// in sync the moment the flag flips.
const VISITED_CHANGE_EVENT = "operations-visited-change";

const readVisited = (): boolean =>
  typeof window !== "undefined" &&
  window.localStorage.getItem(VISITED_STORAGE_KEY) === "true";

export const useOperationsVisited = (): [boolean, () => void] => {
  const [visited, setVisited] = useState(readVisited);

  useEffect(() => {
    const sync = () => setVisited(readVisited());
    window.addEventListener("storage", sync);
    window.addEventListener(VISITED_CHANGE_EVENT, sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener(VISITED_CHANGE_EVENT, sync);
    };
  }, []);

  const markVisited = useCallback(() => {
    window.localStorage.setItem(VISITED_STORAGE_KEY, "true");
    window.dispatchEvent(new Event(VISITED_CHANGE_EVENT));
  }, []);

  return [visited, markVisited];
};
